export const loadingWatcher = {
  data() {
    return {
      loadingEl: null
    }
  },
  watch: {
    loading(newValue) {
      if (newValue) {
        // this.$q.loading.show({ delay: 100 })
        var elem = this.$el.querySelector('.loading-data')
        this.loadingEl = this.$buefy.loading.open({
          container: elem ? elem : null
        })
      } else {
        // this.$q.loading.hide()
        this.loadingEl.close()
        this.loadingEl = null
      }
    }
  }
}
